
export const OTHER_PROGRAMS_TYPES = {
    CHIP: 'CHIP',
    COBRA_COVERAGE: 'COBRA_COVERAGE',
    EMPLOYER_INSURANCE: 'EMPLOYER_INSURANCE',
    MARKETPLACE_COVERAGE: 'MARKETPLACE_COVERAGE',
    MEDICAID: 'MEDICAID',
    MEDICARE: 'MEDICARE',
    NONE: 'NONE',
    OTHER_COVERAGE: 'OTHER_COVERAGE',
    PEACE_CORPS: 'PEACE_CORPS',
    RETIRE_HEALTH_BENEFITS: 'RETIRE_HEALTH_BENEFITS',
    TRICARE: 'TRICARE',
    VETERANS_AFFAIRS_HCP: 'VETERANS_AFFAIRS_HCP'
};


export const OTHER_PROGRAMS_LIST =  [
    {
        'name': 'CHIP',
        'nameId': 'ssap.input.label.chip',
        'type': OTHER_PROGRAMS_TYPES.CHIP,
        'eligible': false
    },
    {
        'name': 'COBRA Coverage',
        'nameId': 'ssap.input.label.cobra',
        'type': OTHER_PROGRAMS_TYPES.COBRA_COVERAGE,
        'eligible': false
    },
    {
        'name': 'Marketplace Coverage',
        'nameId': 'ssap.input.label.marketplace_coverage',
        'type': OTHER_PROGRAMS_TYPES.MARKETPLACE_COVERAGE,
        'eligible': false
    },
    {
        'name': 'Medicaid',
        'nameId': 'ssap.input.label.medicaid',
        'type': OTHER_PROGRAMS_TYPES.MEDICAID,
        'eligible': false
    },
    {
        'name': 'Medicare',
        'nameId': 'ssap.input.label.medicare',
        'type': OTHER_PROGRAMS_TYPES.MEDICARE,
        'eligible': false,
    },
    {
        'name': 'Peace Corps',
        'nameId': 'ssap.input.label.peace_corps',
        'type': OTHER_PROGRAMS_TYPES.PEACE_CORPS,
        'eligible': false
    },
    {
        'name': 'Retiree Health Benefits',
        'nameId': 'ssap.input.label.retire_health_benefits',
        'type': OTHER_PROGRAMS_TYPES.RETIRE_HEALTH_BENEFITS,
        'eligible': false
    },
    {
        'name': 'TRICARE',
        'nameId': 'ssap.input.label.tricare',
        'type': OTHER_PROGRAMS_TYPES.TRICARE,
        'eligible': false
    },
    {
        'name': 'Veterans Affairs(VA) Health Care Program',
        'nameId': 'ssap.input.label.veterans_affairs_hcp',
        'type': OTHER_PROGRAMS_TYPES.VETERANS_AFFAIRS_HCP,
        'eligible': false
    },
    {
        'name': 'Other Coverage',
        'nameId': 'ssap.input.label.other_coverage',
        'type': OTHER_PROGRAMS_TYPES.OTHER_COVERAGE,
        'eligible': false
    },
    {
        'name': 'None of the Above',
        'nameId': 'ssap.input.label.none_of_above',
        'type': OTHER_PROGRAMS_TYPES.NONE,
        'eligible': false
    },
    {
        'name': 'Employer Insurance',
        'nameId': 'common.input.label.non_internationalized_text',
        'type': OTHER_PROGRAMS_TYPES.EMPLOYER_INSURANCE,
        'notSupported': true,
        'eligible': false
    },
];